<template>
  <div>
    <v-card flat color="#fffbf1" class="pa-4 brownBorder">
      <h3 class="">Plaquenil "Safe" Daily Dose Calculator</h3>
      <hr class="mb-6" />
      <div class="d-flex flex-row flex-wrap align-start">
        <div class="shortInput" id="weightInput">
          <v-text-field
            v-model="weight"
            label="Weight"
            class="mr-4"
            type="number"
            :min="50"
            :max="600"
            outlined
            dense
            :messages="otherWeight"
            @blur="validateWeight()"
          ></v-text-field>
        </div>

        <!-- <v-radio-group v-model="weightUnit" row dense>
        <v-radio label="lbs" value="lbs"></v-radio>

        <v-radio label="kg" value="kg"></v-radio>
      </v-radio-group> -->
        <div class="sliderDiv flex-grow-1">
          <v-slider
            v-model="weight"
            :min="minWeight"
            :max="maxWeight"
          ></v-slider>
        </div>

        <div class="ml-4">
          <div>
            5mg/kg x {{ kg.toFixed(1) }}kg =
            <span class="getBig blue--text text--darken-4">
              {{ Math.round(calcResult) }}</span
            >
            mg/day
          </div>
          <div class="caption mt-2">
            This dosage (and less) would be regarded as a lower risk daily dose.
            Dosages greater than this amount will increase the risk of
            retinotoxicity.
          </div>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
// import Name from "../dir/file";

export default {
  name: "PlaquenilWeightCalc",
  props: {},
  data: function () {
    return {
      weight: 130,
      weightUnit: "lbs",
      maxWeight: 300, // lbs
      minWeight: 50, // lbs
      startWeight: 130,
    };
  },
  methods: {
    calcKg(lbs) {
      return lbs * 0.45359;
    },
    calcPounds(kg) {
      return kg / 0.45359;
    },
    validateWeight() {
      if (!this.weight) {
        this.weight = this.startWeight;
      }
      if (this.weight < this.minWeight) {
        this.weight = this.minWeight;
      } else if (this.weight > this.maxWeight) {
        this.weight = this.maxWeight;
      }
    },
  },
  computed: {
    kg: function () {
      return this.weightUnit === "kg" ? this.weight : this.calcKg(this.weight);
    },
    lbs: function () {
      return this.weightUnit === "lbs"
        ? this.weight
        : this.calcPounds(this.weight);
    },
    otherWeight: function () {
      return this.weightUnit === "kg"
        ? this.lbs.toFixed(1) + " lbs"
        : this.kg.toFixed(1) + " kg";
    },
    calcResult: function () {
      return this.kg * 5;
    },
  },
};
</script>

<style scoped>
.shortInput {
  width: 90px;
}
.sliderDiv {
  width: 200px;
}

.brownBorder {
  border: 1px solid #a79e89 !important;
  border-radius: 5px;
  background-color: #fff;
}
.getBig {
  font-size: 1.6rem !important;
  letter-spacing: 0.009375em !important;
  line-height: 1.75rem;
  font-family: Roboto, sans-serif !important;
  font-weight: 700;
}
#weightInput >>> .v-text-field__details {
  /* background-color: transparent; */
  color: gray;
}
#weightInput >>> .v-input__slot {
  background-color: #fff !important;
}

#weightInput >>> .theme--light.v-messages {
  color: rgb(0 0 0 / 84%);
}
</style>
